import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import { Button, TextField, Box, Typography, InputAdornment } from '@mui/material';

import backgroundIllustration from './four.jpg';

const HeroContainer = styled('div')(({ theme }) => ({
  height: '100vh',
  backgroundImage: `url(${backgroundIllustration})`,
  backgroundSize: 'cover',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  position: 'relative',
  '&:before': {
    content: '""',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 0,
  },
}));

const Quote = styled(Typography)(({ theme }) => ({
  fontSize: '3rem',
  fontWeight: 'bold',
  color: '#FFFFFF',
  opacity: 1,
  fontFamily: "'Protest Revolution', sans-serif",
  textAlign: 'center',
  zIndex: 1,
  textTransform: 'uppercase',
  letterSpacing: '0.4rem',
  paddingBottom: theme.spacing(4),
}));

const SignUpForm = styled(Box)(({ theme }) => ({
  width: '90%',
  maxWidth: '420px',
  position: 'relative',
  zIndex: 1,
}));

const SignUpButton = styled(Button)(({ theme }) => ({
  position: 'absolute',
  right: '2px',
  top: '50%',
  transform: 'translateY(-50%)',
  backgroundColor: 'black',
  color: '#FFFFFF',
  fontWeight: '500',
  textTransform: 'none',
  letterSpacing: '0.09em',
  padding: theme.spacing(1, 4),
  transition: 'background-color 0.3s',
  '&:hover': {
    backgroundColor: '#204051',
  },
  boxShadow: 'none',
  fontSize: '0.875rem',
  margin: theme.spacing(0, 1),
  borderRadius: '100px',
}));

const EmailInput = styled(TextField)(({ theme }) => ({
  width: '100%',
  flex: 1,
  color: theme.palette.common.black,
  backgroundColor: '#fff',
  borderRadius: '100px',
  '& .MuiOutlinedInput-root': {
    borderRadius: '50px',
    paddingRight: '0px',
    color: theme.palette.common.black,
    '& fieldset': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
      borderWidth: '2px',
    },
    '&:hover fieldset': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'rgba(0, 0, 0, 0.23)',
    },
  },
  '& .MuiInputBase-input': {
    paddingLeft: theme.spacing(2),
  },
}));

const HeroSection = () => {
  const [email, setEmail] = useState('');

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log('Email submitted:', email);

    const formData = new FormData();
    formData.append('email', email);
    setEmail('');

    try {
      const response = await fetch('https://script.google.com/macros/s/AKfycbz2vUIp1vPVf9Fenpcy9jIOW4FiyEbCL-R51hfHIjJz1YyGOxqYw_7_2ta7otKEZnSxDQ/exec', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        console.log('Email sent successfully.');
      } else {
        console.error('Error sending email.');
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
    
  };

  return (
    <HeroContainer id="heroSection">
      <Quote variant="h2">
        2 minutes of wisdom every friday
      </Quote>
      <SignUpForm component="form" onSubmit={handleSubmit} noValidate autoComplete="off">
        <EmailInput
          variant="outlined"
          placeholder="Your Email Address"
          value={email}
          onChange={handleEmailChange}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <SignUpButton type="submit">
                  SIGN UP
                </SignUpButton>
              </InputAdornment>
            ),
            'aria-label': 'Your Email Address',
          }}
        />
      </SignUpForm>
    </HeroContainer>
  );
};

export default HeroSection;